<template>
  <div class="topic-row">
    <div class="subscription-col ">
      <div class="padding-div"> </div>
      <span class="topic-name">{{topic.topicName}}</span>
    </div>
    <div class="subscription-col email-col">
      <div v-if="topicEmailSetting">
      <div class="imidiate-email">
        <input type="checkbox" v-model="topicEmailSetting.immediate" @change="toggleTopicImmediate">
        <span>Immediate</span>
      </div>
      <!--<div class="daily-email">
        <input type="checkbox" v-model="topicEmailSetting.daily" @change="toggleTopicDaily">
        <span>Daily Digest</span>
      </div>
      <div class="daily-email">
        <input type="checkbox" v-model="topicEmailSetting.weekly" @change="toggleTopicWeekly">
        <span>Weekly Digest</span>
      </div>-->
      </div>
    </div>
    <div class="subscription-col">
      <input type="checkbox" v-model="isSubscribed" @change="toggleTopicSubscription">
      <span>Immediate</span>
    </div>
  </div>
</template>

<script>
import api from '../../../api/api';

export default {
  props: ['topic', 'emailSetting'],
  data() {
    return {
      topicName: '',
      topicId: null,
      isSubscribed: false,
      topicEmailSetting: null,
    }
  },
  mounted() {
    this.topicEmailSetting = this.emailSetting;
  },
  created() {
    this.topicName = this.topic.topicName;
    this.topicId = this.topic.topicID;
    this.isSubscribed = this.topic.subscribed;
  },
  watch: {
    topic(newValue) {
      this.topicName = newValue.topicName;
      this.topicId = newValue.topicID;
      this.isSubscribed = newValue.subscribed;
    }
  },
  methods: {
    toggleTopicImmediate() {
      api.post('/Communication/topics/'+this.topic.topicID, {
        Immediate: this.topicEmailSetting.immediate,
        Id: this.topicEmailSetting.id,
      });
    },
    toggleTopicDaily() {
      api.post('/Communication/topics/'+this.topic.topicID, {
        Daily: this.topicEmailSetting.daily,
        Id: this.topicEmailSetting.id,
      });
    },
    toggleTopicWeekly() {
      api.post('/Communication/topics/'+this.topic.topicID, {
        Weekly: this.topicEmailSetting.weekly,
        Id: this.topicEmailSetting.id,
      });
    },
    toggleTopicSubscription() {
      if(this.isSubscribed === true) {
        api.post('/Subscription/topics', {
          TopicID: this.topicId,
        }).catch(() => {
          this.isSubscribed = !this.isSubscribed;
        }).finally(() => {
          this.$emit('refreshdata');
        });
      }
      else{
        api.delete('/Subscription/topics', {
          TopicID: this.topicId,
        }).catch(() => {
          this.isSubscribed = !this.isSubscribed;
        }).finally(() => {
          this.$emit('refreshdata');
        });
      }
    }
  }
}
</script>

<style scoped>
.padding-div{
    min-width:60px;
    display: inline-block;
}
</style>

